// extracted by mini-css-extract-plugin
module.exports = {"WandaEmailValidation":"SingleWandaEmailValidation_WandaEmailValidation__3yPCR","WandaEmailButtonAlign":"SingleWandaEmailValidation_WandaEmailButtonAlign__3AAaa"};